import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse, ReplyItem, CreateReplyParams } from "./types";

// 回复相关API
export const replyApi = {
  /**
   * 评论帖子
   * @param tid - 帖子ID
   * @param message - 评论内容
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse<ReplyItem>>
   */
  create: (
    tid: number,
    message: string,
    game_id: number,
    language: string
  ): Promise<ApiResponse<ReplyItem>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.REPLY,
      API_CONFIG.ACTIONS.CREATE
    );
    const formData = new FormData();
    formData.append("tid", String(tid));
    formData.append("message", message);
    formData.append("game_id", String(game_id));
    formData.append("language", language);
    return post<ApiResponse<ReplyItem>>(url, formData);
  },

  /**
   * 回复帖子中的评论
   * @param tid - 帖子ID
   * @param message - 回复内容
   * @param reppid - 被回复的评论ID
   * @param game_id - 游戏ID
   * @param language - 语言
   * @returns Promise<ApiResponse<ReplyItem>>
   */
  replyToComment: (
    tid: number,
    message: string,
    reppid: number,
    game_id: number,
    language: string
  ): Promise<ApiResponse<ReplyItem>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.REPLY,
      API_CONFIG.ACTIONS.CREATE
    );
    const formData = new FormData();
    formData.append("tid", String(tid));
    formData.append("message", message);
    formData.append("reppid", String(reppid));
    formData.append("game_id", String(game_id));
    formData.append("language", language);
    return post<ApiResponse<ReplyItem>>(url, formData);
  },
  /**
   * 获取帖子详情回复列表
   * @param tid - 帖子ID
   * @returns Promise<ApiResponse<ReplyItem>>
   */
  getReplyListByTid: (
    toppid: number,
    game_id: number,
    page: number = 1,
    page_size: number = 10
  ): Promise<ApiResponse<ReplyItem>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.REPLY,
      API_CONFIG.ACTIONS.REPLY_DETAIL,
      { toppid, page, page_size, game_id }
    );
    return get<ApiResponse<ReplyItem>>(url);
  },

  /**
   * 删除回复
   * @param tid - 帖子ID
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse>
   */
  delete: (pid: number, game_id: number): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.REPLY,
      API_CONFIG.ACTIONS.DELETE,
      { pid, game_id }
    );
    return post<ApiResponse>(url);
  },
};
